import { IRootState } from './index';
import { IAuthState } from './auth.types';

export const selectAuth = ({ auth }: IRootState): IAuthState => auth;

export const selectIsOfflineMode = (state: IRootState): boolean => selectAuth(state).offlineMode;
